import { FaroCoreApiTypes } from "@stellar/core-api-client";
import {
  PERMISSIONS,
  PermissionKey,
} from "@utils/permissions/permission-matrix";

/** Returns the roles that grant the permission */
export function getRequiredRoles(
  permission: PermissionKey
): readonly FaroCoreApiTypes.AdmUserRole[] {
  const [domain, action] = permission.split(".") as [
    keyof typeof PERMISSIONS,
    string,
  ];

  const roles: Record<string, readonly FaroCoreApiTypes.AdmUserRole[]> =
    PERMISSIONS[domain];

  return roles[action] ?? [];
}

/**
 * Whether any of the given roles grants the permission.
 * No roles (e.g. not loaded yet) grants nothing.
 */
export function hasPermission(
  roles: readonly FaroCoreApiTypes.AdmUserRole[],
  permission: PermissionKey
): boolean {
  const requiredRoles = getRequiredRoles(permission);

  return roles.some((role) => requiredRoles.includes(role));
}

/** Explains which roles are needed for the permission, to show on a disabled control */
export function getDeniedReason(permission: PermissionKey): string {
  const requiredRoles = getRequiredRoles(permission);

  return `Requires the ${requiredRoles.join(" or ")} role`;
}
